export const theme = {
    colors: {
        primary: '#eebf4f',
        buff: '#F8E5B9',
        revolver: '#363639',
        white: '#ffffff',
        black: '#000000',
        gray: '#58585b',
        athens_gray: '#F4F4F5',
        iron: '#D4D5D5',
        purple: '#52489C',
        purple_dark: '#4D41AB',
        light_purple: '#8177C7',
        blue: '#1976d2',
        champagne: '#FAEAC5',
        old_lace: '#FDF9ED',
        golden_sand: '#F1CC72',
        primary_90: 'rgba(238, 191, 79, .9)',
        primary_50: 'rgba(238, 191, 79, .5)',
        primary_40: 'rgba(238, 191, 79, .4)',
        primary_20: 'rgba(238, 191, 79, .2)',
        primary_10: 'rgba(238, 191, 79, .1)',
        primary_05: 'rgba(238, 191, 79, .05)',
        white_03: 'rgba(255, 255, 255, 0.03)',
        rock_blue: '#afbdcf',
        concrete: '#F3F3F3',
        rolling_stone: '#777879',
        light_gray: '#CBCBCB',
        light_gray_overlay: '#CBCBCB4D',
        border_gray: '#e6e6e6',
        shadow: '#4d3d091f',
        dark_gray: '#363639',
        darker_gray: '#272727',
        error: 'red',
        white_overlay: 'rgba(255, 255, 255, 0.5)',
        highlight: '#F7F7F7',
        black_overlay: 'rgba(0, 0, 0, 0.5)',
        light_red: 'rgba(215, 77, 77, 0.1)',
        dark_red: 'rgba(156, 72, 72, 1)',
        dark_green: '#4CAF50',
        dark_orange: '#FF9800',
        red: '#F44336',
        yellow: '#F5D995',
        bombay: '#A9AAAC',
        pearl_lusta: '#FCF2DC',
        gray_10: 'rgba(244, 244, 245, 1)',
        gray_20: 'rgba(230, 230, 230, 1)',
        gray_50: 'rgba(148, 149, 151, 1)',
        gray_80:'rgba(54, 54, 57, 1)',
    },
    font: {
        size: {
            heading: '64px',
            title: '36px',
            header: '24px',
            normal: '18px',
            base: '16px',
            medium: '14px',
            small: '12px',
            table_heading: '11px',
        },
        weight: {
            bold: 700,
            semi_bold: 600,
            normal: 400,
            medium: 500,
            light: 300,
            thin: 200,
        },
        letter_spacing: {
            spatially: '3.6px',
            none: '0',
        },
        line_height: {
            spatially: 1.5,
        },
    },
    breakpoints: {
        tablet: '768px',
        desktop: '1200px',
    },
    transition: {
        background: 'background-color 0.2s ease',
        all: 'all 0.2s linear',
        border: 'border-color 0.3s ease-in',
        stroke: 'stroke 0.2s ease',
        borderAndColor: 'color 0.2s ease, border-color 0.2s ease',
    },
    shadow: {
        autofill: '0 0 0px 1000px #fff inset',
        dropdown: '0px 8px 20px #0000001F',
        table_row: '0px 4px 12px #00000014;',
        settings: '0px 0px 10px #0000001f;',
        ellipsis: '-1px 2px 14px 2px #0000001f;',
    },
    autofill: {
        off: 'autofill-off',
        on: 'autofill-on',
    },
    padding: {
        base: '16px',
        narrow: '10px',
        app: '36px 24px',
    },
    z_index: {
        dropdown: 50,
        modal: 100,
        loading: 9999,
    },
    height: {
        navbar: '62px',
        table_row: '56px',
    },
};
